import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/snake-rescue', label: 'Snake Rescue' },
    { path: '/workshops', label: 'Workshops' },
    { path: '/safety-audit', label: 'Safety Audit' },
    { path: '/areas', label: 'Areas We Serve' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="site-logo-link">
            <img
              src="/logo-512.png"
              alt="Snake Catchers Bangalore logo"
              className="w-12 h-12 sm:w-14 sm:h-14 object-contain"
              data-testid="site-logo-img"
            />
            <div>
              <span className="block text-lg sm:text-xl font-bold text-gray-900 leading-tight">Snake Catchers Bangalore</span>
              <span className="block text-xs text-emerald-600">24/7 Emergency Service</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-emerald-600 ${
                  isActive(link.path) ? 'text-emerald-600' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop Call Button */}
          <a href="tel:+918310755854" className="hidden lg:block">
            <Button className="bg-emerald-600 hover:bg-emerald-700 text-white">
              <Phone className="mr-2 h-4 w-4" />
              Call Now
            </Button>
          </a>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 text-sm font-medium transition-colors hover:text-emerald-600 ${
                  isActive(link.path) ? 'text-emerald-600' : 'text-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;